import { usePreviewSecret } from './PreviewSecretContext'

export const useIsPreview = () => {
  const previewModeSecret = usePreviewSecret()
  return !!previewModeSecret
}
